
(function() {
  // Find the HeyLight modal element 
  function findHeyLightModal(infoButton) {
    var container = infoButton.closest('.shoppy-heylight');
    if (!container) return null;
    
    var sibling = container.nextElementSibling;
    while (sibling && !sibling.classList.contains('shoppy-heylight-modal')) {
      sibling = sibling.nextElementSibling;
    }
    return sibling;
  }

  // Initialize the HeyLight modal
  function initHeyLightModal() {
    var infoButton = document.querySelector('[data-heylight-modal-trigger]:not([data-init])');
    if (!infoButton) return;
    
    var modal = findHeyLightModal(infoButton);
    if (!modal || !modal.querySelector('iframe')) return;

    infoButton.setAttribute('data-init', 'true');
    infoButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (modal) {
        requestAnimationFrame(function() {
          modal.setAttribute('open', '');
        });
      }
    });
  }

  // Close modal
  if (!window.heylightMessageListener) {
    window.addEventListener('message', function(e) {
      if (e.data && e.data['heidi-action-toggle-iframe']) {
        var modal = document.querySelector('.shoppy-heylight-modal[open]');
        if (modal) modal.removeAttribute('open');
      }
    });
    window.heylightMessageListener = true;
  }

  // Setup MutationObserver to reinitialize modal when quick-add content loads
  function setupQuickAddObserver() {
    var quickAddModal = document.querySelector('quick-add-modal');
    if (!quickAddModal) return;

    var observer = new MutationObserver(function() {
      if (quickAddModal.hasAttribute('open')) {
        setTimeout(initHeyLightModal, 300);
      }
    });

    observer.observe(quickAddModal, {
      attributes: true,
      attributeFilter: ['open'],
      childList: true,
      subtree: true
    });
  }

  // Initialize on page load
  function init() {
    initHeyLightModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      setupQuickAddObserver();
    });
  } else {
    init();
    setupQuickAddObserver();
  }

  document.addEventListener('shopify:section:load', init);

  // Check for dynamically created quick-add-modal
  setInterval(function() {
    var quickAddModal = document.querySelector('quick-add-modal');
    if (quickAddModal && !quickAddModal.dataset.heylightObserved) {
      quickAddModal.dataset.heylightObserved = 'true';
      setupQuickAddObserver();
    }
  }, 1000);

  // Boutique Appointment Form Modal - Open when hash is present
  function openBoutiqueAppointmentModal() {
    if (window.location.hash === '#boutique-appointment-form') {
      var modal = document.getElementById('boutique-appointment-form');
      if (modal && typeof modal.show === 'function') {
        modal.show();
      }
    }
  }

  // Remove hash from URL when modal is closed
  function handleBoutiqueModalClose() {
    var modal = document.getElementById('boutique-appointment-form');
    if (!modal) return;

    // Listen to the modalClosed event dispatched by ModalDialog
    document.body.addEventListener('modalClosed', function() {
      if (window.location.hash === '#boutique-appointment-form') {
        // Remove hash from URL without triggering hashchange
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, null, window.location.pathname + window.location.search);
        } else {
          window.location.hash = '';
        }
      }
    });

    // Also use MutationObserver as fallback
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (!modal.hasAttribute('open') && window.location.hash === '#boutique-appointment-form') {
            // Small delay to ensure modal is fully closed
            setTimeout(function() {
              if (window.history && window.history.replaceState) {
                window.history.replaceState(null, null, window.location.pathname + window.location.search);
              } else {
                window.location.hash = '';
              }
            }, 100);
          }
        }
      });
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  // Initialize boutique appointment modal
  function initBoutiqueAppointmentModal() {
    openBoutiqueAppointmentModal();
    handleBoutiqueModalClose();
  }

  // Check on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBoutiqueAppointmentModal);
  } else {
    initBoutiqueAppointmentModal();
  }

  // Check on hash change
  window.addEventListener('hashchange', openBoutiqueAppointmentModal);
})();
